import { DAYS_OF_WEEK } from "./types";

/**
 * Studio-wide settings persisted under `tempo.studioSettings.v1`. Designed to
 * map cleanly to a future `studios` row in Supabase.
 *
 * @typedef {Object} StudioSettings
 * @property {string} studioName            Display name on the header.
 *                                          Empty string falls back to "Tempo".
 * @property {number} monthlyTargetMultiplier
 *                                          Per-student target = days × this.
 *                                          1..6 sane range, default 4.
 * @property {string[]} workingDays         Days the studio runs lessons.
 *                                          Subset of DAYS_OF_WEEK.
 * @property {string} [updatedAt]
 */

export const DEFAULT_SETTINGS = Object.freeze({
    studioName: "",
    monthlyTargetMultiplier: 4,
    workingDays: [...DAYS_OF_WEEK],
});

/** Coerce any persisted value into a valid settings object. */
export function normalizeSettings(raw) {
    const r = raw && typeof raw === "object" ? raw : {};
    const mult = Number(r.monthlyTargetMultiplier);
    const workingDays = Array.isArray(r.workingDays)
        ? r.workingDays.filter((d) => DAYS_OF_WEEK.includes(d))
        : DEFAULT_SETTINGS.workingDays;
    return {
        studioName:
            typeof r.studioName === "string" ? r.studioName.trim() : "",
        monthlyTargetMultiplier:
            Number.isFinite(mult) && mult >= 1 && mult <= 6
                ? Math.round(mult)
                : DEFAULT_SETTINGS.monthlyTargetMultiplier,
        workingDays:
            workingDays.length > 0 ? workingDays : DEFAULT_SETTINGS.workingDays,
        ...(r.updatedAt ? { updatedAt: r.updatedAt } : {}),
    };
}

/** Human-readable display name with fallback. */
export function displayStudioName(settings) {
    return (settings && settings.studioName && settings.studioName.trim()) ||
        "Tempo";
}
